export interface ConstraintDescription {
  markdown: string
}

export interface Constraints {
  assets: Record<string, ConstraintDescription>
  operation_modes: Record<string, ConstraintDescription>
}
